import Helmet from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { SimplePageLayout } from 'components/layouts/SimplePageLayout';
import { PageLayout } from '../../../components/PageLayout';
import { ResetPasswordForm } from './ResetPasswordForm';

export const Content = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('resetPassword.title')}</title>
      </Helmet>
      <SimplePageLayout>
        <ResetPasswordForm />
      </SimplePageLayout>
    </>
  );
};

export const ResetPassword = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <PageLayout
      data-cname="ResetPasswordPage"
      headerBarProps={{ action: '/login', title: t('resetPassword.title') }}
    >
      <Content />
    </PageLayout>
  );
};
